export default function printProduct() {
    const printButton = document.querySelector('.print');
    if (printButton === null) return;
    printButton.addEventListener('click', function() {
        window.print();
    });
}